export const OPEN_INVOICES_PATH = "/billing/invoices/current?status=OPEN";
export const BILLING_MAILTO = "mailto:billing@certn.co";
export const LEGACY_BANNER = "legacy_banner";
export const SCHEDULE_BANNER = "banner";
export const POPUP = "popup";
